import { jsx as _jsx } from "react/jsx-runtime";
import { BadgeAlert, Optional } from '@honda-canada/design-system-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import themeStyles from './SpecialOfferCard.styles';
const StyledLoyaltyBadge = themeStyles.apply(BadgeAlert, 'StyledLoyaltyBadge');
const LoyaltyBadge = ({ hasLoyaltyOffer = false }) => {
    const { t } = useTranslation();
    return (_jsx(Optional, { when: hasLoyaltyOffer, children: _jsx(StyledLoyaltyBadge, { labelText: t('Pages.SpecialOffers.loyaltyOfferBadgeLabel'), variant: "available" }) }));
};
export default LoyaltyBadge;
